import { ChangeDetectorRef, Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, TemplateRef, ViewContainerRef, AfterViewInit } from "@angular/core";
import { Suscripcion } from "src/app/models/suscripcion";
import { SuscripcionesService } from "src/app/services/suscripciones.service";
import { ToastrService } from "ngx-toastr";
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ChartItem } from '../multicharts-dialog/multicharts-dialog.component';
import { SseService } from 'src/app/services/SseService';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isoDeIsooper } from 'src/app/shared/utils/isooper.util';
import { ColaOrdenesService } from '../../../services/cola-ordenes.service';
import { GestionService } from 'src/app/services/gestion.services';
import { DatePipe } from '@angular/common';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { ActivatedRoute } from '@angular/router';
import { TemaService } from '../../../services/tema.services';
import { NotificacionService } from "src/app/services/notificacion.service";
import { CdkTableVirtualScrollDataSource } from "ng-table-virtual-scroll";
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { HelpDialogComponent, HelpDialogData } from '../../common/help-dialog/help-dialog.component';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { WalletMetrics, walletMetricsKey } from 'src/app/shared/utils/wallet-metrics.util';
import { SlTpBrokerService } from 'src/app/services/sltp-broker.service';

/** Estados de operaciones que la automatización no llegó a enviar al broker. */
const ESTADOS_NO_ENVIADAS = [
  'MARGEN-INSUFICIENTE', 'MARGEN-BKR-INSUFICIENTE', 'RIESGO-INSUFICIENTE',
  'AUTOMATIZACION-DETENIDA', 'BROKER-CERRADO', 'ALGO-TRADING-OFF', 'PENDIENTE-ENVIO', 'ERROR',
  'CANCELADA-COLA', 'EXPIRADA-COLA'
];

@Component({
  selector: 'app-suscripciones-confirmar',
  templateUrl: './suscripciones-confirmar.component.html',
  styleUrls: ['./suscripciones-confirmar.component.scss']
})
export class SuscripcionesConfirmarComponent implements OnInit, OnDestroy, AfterViewInit {
  // Embedded mode inputs (take priority over queryParams when set)
  @Input() idcarteraInput: number = 0;
  @Input() moduloInput: string = '';
  @Input() carteraInput: string = '';
  @Input() desdeInput: any = null;
  @Input() idcarterasuscritaInput: number = 0;
  @Input() tipoBrokerInput: string = '';
  @Input() metaApiAccountIdInput: string = '';
  @Input() brokerClockTextInput: string = '';
  @Input() brokerClockLabelInput: string = '';
  // Embebido en broker: el evento 'storage' no llega a la misma pestaña, así que el padre empuja las métricas
  @Input() set walletMetricsInput(value: WalletMetrics | null | undefined) {
    if (value === undefined) return;
    this.walletMetrics = value;
    this.cdr.markForCheck();
  }

  public apiIbkrAvailable: boolean = localStorage.getItem('apiIbkrAvailable') === 'false' ? false : true;
  public fecharegistrosuscripcion: string = '';
  private storageListener: any;
  selectedElement: any;
  public queryParams: string;
  isDarkTheme: boolean;
  @ViewChild('contextMenu') contextMenu: TemplateRef<any>;
  @ViewChild('viewportOperacionesGestor', { static: false }) viewportOperacionesGestor!: CdkVirtualScrollViewport;
  private overlayRef: OverlayRef | null = null;
  listaSuscripciones: Suscripcion[];
  public isDark: boolean = false;
  theme: string;
  licencia: string;
  idcartera: number = 0;
  filaSeleccionada: any;
  modulo: string = '';
  cartera: string = '';
  desde: string = '';
  public stoplosscartera: number = 20;
  public bajista: boolean = false;
  displayedColumns: string[] = ['group', 'subcarteras', 'suscrito', 'auto', 'buscar'];
  panelOpenState = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }
  idcarterasuscrita: number = 0;
  activadoauto: boolean = false;
  isOco: boolean = false;
  @Output() autoActivado = new EventEmitter<void>();
  @Output() ocoChange = new EventEmitter<boolean>();
  public opedataGestor = new CdkTableVirtualScrollDataSource<any>();
  /** Operaciones de la cartera (BROKER); alimentan el aviso de no enviadas y el fallback de gráficas. */
  allOpedataRaw: any[] = [];
  operacionesNoEnviadas: any[] = [];

  onOcoChange(checked: boolean) {
    this.isOco = checked;
    localStorage.setItem('oco_' + this.idcartera, String(checked));
    this.ocoChange.emit(checked);
  }

  showChartsSection = false;
  highlightedIsoopers: string[] = [];
  chartsData: { charts: ChartItem[] } = { charts: [] };
  private colaOrdenesSubscription: Subscription;
  private colaOrdenesSubscriptionGestor: Subscription;
  public idCarteraBroker: String = '0';
  public tipoBroker: string = 'IBKR';
  public metaApiAccountId: string = '';
  private brokerOffsetMin: number | null = null;
  public walletMetrics: WalletMetrics | null = null;

  // Column configuration for GESTOR table
  tableColumnsOperacionesGestor: TableColmuns[] = [
    { id: 'position', name: 'Nº', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'ticker', name: 'ISO', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'precioentradareal', name: 'Precio Entrada', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'preciosalidareal', name: 'Precio Salida', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoplossinicial', name: 'Stop Loss Inicial / Broker', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoploss', name: 'Stop Loss Actual', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'tipoOperacion', name: 'Tipo', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'fecha', name: 'Fecha', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'estado', name: 'Estado', isShow: true, isDate: false, isNumber: false, isString: true }
  ];
  displayedColumnsOperacionesGestor: string[] = this.tableColumnsOperacionesGestor.filter(col => col.isShow).map(col => col.id);

  private isoPairMap = new Map<string, string>();
  private carteraIconMap = new Map<string, string>();
  private carteraIconCounter = 0;
  private symbols = ['✔'];
  private symbol2 = ['🟠', '🟢'];
  private carteraIcons = ['💼', '💰', '📈', '📉', '💹', '🏛️', '🏢'];

  constructor(
    private overlay: Overlay,
    private route: ActivatedRoute,
    private themeService: TemaService,
    private viewContainerRef: ViewContainerRef,
    public dialog: MatDialog, private cdr: ChangeDetectorRef,
    private cd: ChangeDetectorRef,
    private suscripcionesService: SuscripcionesService,
    private _sseservice: SseService,
    private toastr: ToastrService,
    private _cookieService: CookieService,
    private colaOrdenesService: ColaOrdenesService,
    private datePipe: DatePipe,
    private _gestionsv: GestionService, private notificacionService: NotificacionService,
    private brokerTimeService: BrokerTimeService,
    private sltp: SlTpBrokerService
  ) { }

  private resolveBrokerOffset(): void {
    if (this.tipoBroker !== 'METAAPI') { this.brokerOffsetMin = null; return; }
    const accountId = this.metaApiAccountId || this.cartera;
    this.brokerTimeService.getOffsetMinutes(accountId).subscribe(offsetMin => this.brokerOffsetMin = offsetMin);
  }

  private setOperaciones(operaciones: any[]): void {
    this.allOpedataRaw = this.sltp.transformarOperaciones(operaciones, this.idcartera);
    this.operacionesNoEnviadas = this.allOpedataRaw
      .map(op => ({ ...op, estado: this.estadoNoEnviada(op) }))
      .filter(op => !!op.estado);
  }

  /**
   * Estado de no envío de la operación, o '' si se envió. En la cola en memoria `estado` ya es el estado
   * de envío; en operaciones/{idcartera} (al refrescar) `estado` es el status de la orden en tbl_orden y el
   * de envío llega en `estadoEnvio`. Solo cuenta sin orden (N/A): muchas filas siguen en PENDIENTE-ENVIO
   * aunque la orden ya se ejecutó.
   */
  private estadoNoEnviada(op: any): string {
    if (ESTADOS_NO_ENVIADAS.includes(op.estado)) return op.estado;
    const envio = op.estadoEnvio ? String(op.estadoEnvio).toUpperCase() : '';
    return op.estado === 'N/A' && ESTADOS_NO_ENVIADAS.includes(envio) ? envio : '';
  }

  ngOnInit(): void {
    this.idCarteraBroker = localStorage.getItem('idcarterabroker') || '0';
    this.apiIbkrAvailable = localStorage.getItem('apiIbkrAvailable') === 'false' ? false : true;
    this.storageListener = (event: StorageEvent) => {
      if (event.key === 'idcarterabroker') {
        this.idCarteraBroker = event.newValue || '0';
        this.cdr.detectChanges();
      } else if (event.key === 'apiIbkrAvailable') {
        this.apiIbkrAvailable = event.newValue === 'false' ? false : true;
        this.cdr.detectChanges();
      } else if (this.idcartera > 0 && event.key === walletMetricsKey(this.idcartera)) {
        try { this.walletMetrics = event.newValue ? JSON.parse(event.newValue) : null; } catch { this.walletMetrics = null; }
        this.cdr.detectChanges();
      }
    };

    window.addEventListener('storage', this.storageListener);
    this.licencia = this._cookieService.get('auth_token');
    // Dual-mode: use @Input() bindings when embedded inside broker, otherwise fall back to URL queryParams
    if (this.idcarteraInput > 0) {
      this.idcartera = this.idcarteraInput;
      this.modulo = this.moduloInput.toUpperCase() || 'BROKER';
      this.cartera = this.carteraInput.toUpperCase();
      this.desde = this.desdeInput;
      this.idcarterasuscrita = this.idcarterasuscritaInput;
      this.tipoBroker = this.tipoBrokerInput || 'IBKR';
      this.metaApiAccountId = this.metaApiAccountIdInput;
      this.resolveBrokerOffset();
      // Ensure the shared service polls for the correct cartera and load data immediately
      this.colaOrdenesService.setIdCartera(this.idcartera);
      this.refrescar();
    } else {
      this.route.queryParams.subscribe(params => {
        if (Object.keys(params).length > 0) {
          console.log('params:', params);
          console.log(" idcartera " + params['idcartera']);
          this.idcartera = Number(params['idcartera']);
          this.modulo = params['modulo'].toUpperCase();
          this.cartera = params['cartera'].toUpperCase();
          this.desde = params['desde'];
          this.idcarterasuscrita = Number(params['idcarterasuscrita']);
          this.tipoBroker = params['tipoBroker'] ?? 'IBKR';
          this.metaApiAccountId = params['metaApiAccountId'] ?? '';
          this.resolveBrokerOffset();
        }
      });
    }
    // Después de resolver idcartera (inputs o queryParams síncronos) para leer la clave de esta cartera
    this.loadWalletMetrics();
    this.consultarSuscripciones();

    let dataJson = { idcartera: this.idcartera };
    this._sseservice.apiPostNew('getCarteraById', dataJson, this.licencia).subscribe({
      next: (data: any) => {
        console.log(data.cartera);
        this.bajista = data.cartera.bajista;
        this.stoplosscartera = data.cartera.stopLoss;
        console.log(this.stoplosscartera);
      }
    });

    this.themeService.valDarkTheme.subscribe(isDark => {
      this.isDarkTheme = isDark;
      this.theme = isDark ? 'dark-theme' : 'light-theme';
    });
    this.activadoauto = this._cookieService.check('auto' + this.idcartera);
    this.isOco = localStorage.getItem('oco_' + this.idcartera) === 'true';
    if (this.isOco) this.ocoChange.emit(true);
    this.colaOrdenesSubscription = this.colaOrdenesService.operaciones$.subscribe(
      operaciones => this.setOperaciones(operaciones)
    );

    this.colaOrdenesSubscriptionGestor = this.colaOrdenesService.operacionesGestor$.subscribe(
      operaciones => {
        console.log('Operaciones Gestor actualizadas:', operaciones);
        this.opedataGestor.data = this.sltp.transformarOperaciones(operaciones, this.idcartera);
      }
    );

    if (this.modulo === 'GESTOR') {
      this.displayedColumns.splice(3, 0, 'gestor');
    }
  }

  ngAfterViewInit() {
    this.actualizarViewport();
  }

  ngOnDestroy() {
    window.removeEventListener('storage', this.storageListener);
    this.colaOrdenesSubscription?.unsubscribe();
    this.colaOrdenesSubscriptionGestor?.unsubscribe();
  }

  private loadWalletMetrics(): void {
    if (this.walletMetrics || !(this.idcartera > 0)) return; // ya lo empujó el padre, o sin cartera (diálogo)
    const raw = localStorage.getItem(walletMetricsKey(this.idcartera));
    if (raw) { try { this.walletMetrics = JSON.parse(raw); } catch {} }
  }

  get riesgoDisponible(): number {
    if (!this.walletMetrics) return 0;
    return +(this.walletMetrics.riesgomaximo - this.walletMetrics.riesgoActual).toFixed(2);
  }

  get margenDisponible(): number {
    if (!this.walletMetrics) return 0;
    return +(this.walletMetrics.valorLiquidativo * this.walletMetrics.controlMarginCall / 100 - this.walletMetrics.margen).toFixed(2);
  }

  formatUnixTime(unixTime: number): string {
    const date = new Date(unixTime * 1000);
    if (this.tipoBroker === 'METAAPI') {
      const hora = this.brokerTimeService.formatTime(date, this.brokerOffsetMin);
      if (!hora) return '';
      return `${hora} ${this.brokerTimeService.formatDate(date, this.brokerOffsetMin)}`;
    }
    return this.datePipe.transform(date, 'HH:mm:ss dd-MM-yyyy') || '';
  }

  entregarfechadeorderref(order_ref?: string): number {
    return Number(order_ref?.replace('nctminvst', '').split('-')[0].substring(0, 13) ?? 0)/1000;
  }

  /** Fecha de la operación: la del order_ref si existe, si no fechaOperacion. */
  fechaOperacion(op: any): string {
    const ts = this.entregarfechadeorderref(op.order_ref);
    return ts ? this.formatUnixTime(ts) : (op.fechaOperacion ?? '');
  }

  formatPrice(value: number | undefined, element: any): string {
    return this.sltp.formatPrice(value, element);
  }

  // Toggle column visibility for GESTOR operations table
  toggleColumnVisibilityGestor(id: string) {
    const column = this.tableColumnsOperacionesGestor.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumnsOperacionesGestor = this.tableColumnsOperacionesGestor
        .filter(col => col.isShow)
        .map(col => col.id);
    }
  }

  // Update viewport size for virtual scroll
  actualizarViewport() {
    if (this.viewportOperacionesGestor) {
      this.viewportOperacionesGestor.checkViewportSize();
    }
  }

  consultarSuscripciones() {
    this.suscripcionesService.listarSuscripcionesConfirmar(this.cartera).subscribe({
      next: (value) => {
        console.log(value);
        this.listaSuscripciones = value.filter((suscripcion: { idcartera: number; }) => {
          return suscripcion.idcartera === this.idcarterasuscrita;
        });
        if (this.listaSuscripciones.length > 0) {
          this.fecharegistrosuscripcion = this.listaSuscripciones[0].fechasuscripcion;
        }

        console.log(this.fecharegistrosuscripcion);
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error consultando suscripciones");
      },
    });
  }


  suscribirModeloAuto(suscribirse: boolean, suscripcion: Suscripcion) {
    if (suscribirse) {
      this.registrarSuscripcionAuto(suscripcion);
    } else if (!suscribirse) {
      this.eliminarSuscripcionAuto(suscripcion);
      this.notificacionService.updateTimerNotification(`Cancelado`, '');
      setTimeout(() => {
        this.notificacionService.updateTimerNotification(``, '');
      }, 2000);
    }
  }
  selectRow(row: any) {
    this.filaSeleccionada = row;
  }
  registrarSuscripcion(suscripcion: Suscripcion) {
    this.suscripcionesService.registrarSuscripcion(suscripcion).subscribe({
      next: (value: Suscripcion) => {
        let sus = this.listaSuscripciones.find(
          (s) =>
            s.idcartera == suscripcion.idcartera &&
            s.idmodelo == suscripcion.idmodelo
        );
        if (sus) {
          sus.idsuscripcion = value.idsuscripcion;
        }
        this.toastr.success("Suscripción exitosa");
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error registrando la suscripción");
      },
    });
  }

  registrarSuscripcionAuto(suscripcion: Suscripcion) {
    this._sseservice.apiGetNew('revisarSuscrito?nombre=' + encodeURIComponent(this.cartera)).subscribe({
      next: (data: any) => {
        if (data.status === 'success') {
          suscripcion.idcartera = this.idcartera;
          this._cookieService.set("auto" + this.idcartera, "true");
          this._gestionsv.updateActivadoAuto(this.idcartera);

          this.suscripcionesService.registrarSuscripcionAuto(suscripcion).subscribe({
            next: (value: Suscripcion) => {
              let sus = this.listaSuscripciones.find(
                (s) =>
                  s.idcartera == this.idcartera &&
                  s.idmodelo == suscripcion.idmodelo
              );
              if (sus) {
                sus.idsuscripcion = value.idsuscripcion;
              }
              this.toastr.success("Automatizacion exitosa");
              this.autoActivado.emit();
              this.cd.markForCheck();
            },
            error: (err) => {
              this.toastr.error("Ocurrió un error registrando la suscripción");
            },
          });
        } else {
          this.toastr.error("No es posible automatizar una cartera no suscrita.");
          this.activadoauto = false;
        }
      }
    });
  }

  eliminarSuscripcion(suscripcion: Suscripcion) {
    this.suscripcionesService
      .eliminarSuscripcion(suscripcion.idsuscripcion)
      .subscribe({
        next: (value) => {
          let sus = this.listaSuscripciones.find(
            (s) =>
              s.idcartera == suscripcion.idcartera &&
              s.idmodelo == suscripcion.idmodelo
          );
          if (sus) {
            sus.idsuscripcion = 0;
          }
          this.toastr.success("Suscripción eliminada exitosamente");
          this.cd.markForCheck();
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error eliminando la suscripcion");
        },
      });
  }

  eliminarSuscripcionAuto(suscripcion: Suscripcion) {
    suscripcion.idcartera = this.idcartera;
    this._cookieService.delete("auto" + this.idcartera);
    this._gestionsv.updateActivadoAuto(this.idcartera);

    this.suscripcionesService
      .eliminarSuscripcionAuto(suscripcion.idcartera)
      .subscribe({
        next: (value) => {
          let sus = this.listaSuscripciones.find(
            (s) =>
              s.idcartera == this.idcartera &&
              s.idmodelo == suscripcion.idmodelo
          );
          if (sus) {
            sus.idsuscripcion = 0;
          }
          this.toastr.success("Automatizacion eliminada exitosamente");
          this.cd.markForCheck();
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error eliminando la suscripcion");
        },
      });
  }

  cambiarHoraEntradaSalida(suscripcion: Suscripcion) {
    if (suscripcion.suscrito && suscripcion.idsuscripcion) {
      this.registrarSuscripcion(suscripcion);
    }
  }

  setAll(completed: boolean) {
    if (this.listaSuscripciones == null) {
      return;
    }
    this.listaSuscripciones.forEach((t) => (t.suscrito = completed));
  }
  eliminar(suscripcion: Suscripcion) {
    console.log(suscripcion);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '200px',
      panelClass: this.theme,
      data: {
        msj: '!Atención! La Cartera  será eliminada en todos los módulos del programa.'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        const idcartera = {
          idcartera: Number(suscripcion.idcartera),
        };
        this._sseservice.apiPostNew('eliminarcartera', idcartera, this.licencia).subscribe(response => {
          console.log(response);
          this.consultarSuscripciones();

        });
      } else {

        console.log('La acción fue cancelada');
      }
    });
  }

  // Menú contextual de la tabla GESTOR
  onContextMenu(event: MouseEvent, row: any): void {
    event.preventDefault();
    this.selectedElement = row;
    this.closeContextMenu();
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x: event.clientX, y: event.clientY })
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });

    this.overlayRef.attach(new TemplatePortal(this.contextMenu, this.viewContainerRef, {
      $implicit: row
    }));

    this.overlayRef.backdropClick().subscribe(() => this.closeContextMenu());
  }

  closeContextMenu(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  onContextMenuAction(action: 'enmodelo' | 'grafica', elements: any): void {
    switch (action) {
      case 'enmodelo':
        this._sseservice.apiGetNew('cartera/' + elements.idmodelo).subscribe({
          next: () => {
            this.queryParams = new URLSearchParams({
              idNectum: elements.idNectum,
              nombreComp: elements.nombrecompania,
              idModelo: elements.idmodelo,
              isModelo: 'modelo'
            }).toString();
            window.open('/grafica-modelo/' + this.queryParams, '_blank');
          }
        });
        break;
      case 'grafica':
        this.queryParams = new URLSearchParams({
          idNectum: elements.idNectum,
          nombreComp: elements.nombrecompania,
          idModelo: '0',
          isModelo: 'grafica'
        }).toString();
        window.open('/grafica-modelo/' + this.queryParams, '_blank');
        break;
    }
    this.closeContextMenu();
  }

  getEstadoIcon(estado: string): string {
    switch (estado?.toUpperCase()) {
      case 'COMPLETADO':
        return 'check_circle';
      case 'EN_PROCESO':
        return 'hourglass_empty';
      case 'RECHAZADO':
        return 'cancel';
      case 'PENDIENTE':
        return 'pending';
      case 'CANCELADO':
        return 'cancel';
      case 'N/A':
        return 'help_outline';
      case null:
        return 'help_outline';
      case 'ERROR':
        return 'error';
      case 'PENDIENTE-ENVIO':
        return 'pending_actions';
      case 'FILLED':
        return 'check_circle';
      case 'PRESUBMITTED':
        return 'hourglass_top';
      case 'SUBMITTED':
        return 'hourglass_bottom';
      case 'CANCELLED':
        return 'cancel';
      case 'INNACTIVE':
        return 'do_not_disturb';
      case 'AUTOMATIZACION-DETENIDA':
        return 'pause_circle_filled';
      case 'MARGEN-BKR-INSUFICIENTE':
        return 'warning';
      case 'MARGEN-INSUFICIENTE':
        return 'warning';
      case 'RIESGO-INSUFICIENTE':
        return 'warning';
      case 'BROKER-CERRADO':
        return 'close';
      case 'ALGO-TRADING-OFF':
        return 'block';
      case 'CANCELADA-COLA':
        return 'cancel_schedule_send';
      case 'EXPIRADA-COLA':
        return 'timer_off';

      default:
        return 'help_outline';
    }
  }

  // Portfolio Labs solo tiene sentido si la cartera combina más de una subcartera
  get tieneVariasSubcarteras(): boolean {
    const s: any = this.listaSuscripciones?.[0];
    const csv = String(s?.idsubcarterascartera ?? s?.idsubcarteras ?? '');
    return csv.split(',').filter(id => id.trim()).length > 1;
  }

  geticonoscartera(cartera: string): string {
    if (!this.carteraIconMap.has(cartera)) {
      const icon = this.carteraIcons[this.carteraIconCounter++];
      this.carteraIconMap.set(cartera, icon);
      return icon;
    } else {
      return this.carteraIconMap.get(cartera) || '';
    }

  }

  getPairSymbol(isooper: string): string {
    if (!this.isoPairMap.has(isooper)) {
      // Contar ocurrencias de este ISO
      const data = this.opedataGestor.data;
      const count = data.filter(item => item.isooper === isooper).length;
      const statusFiled = data.filter(item => item.isooper === isooper && item.estado === 'FILLED').length;
      if (count > 1) {
        this.isoPairMap.set(isooper, this.symbols[0]);
      } else {
        this.isoPairMap.set(isooper, statusFiled > 0 ? this.symbol2[0] : this.symbol2[1]);
      }
    }

    return this.isoPairMap.get(isooper) || '';
  }

  openChartsDialog(suscripcion: any): void {
    if (this.showChartsSection) {
      this.showChartsSection = false;
      return;
    }
    const charts: ChartItem[] = [];

    if (suscripcion.idsubcarteras && suscripcion.subcarteras) {
      // Primary path: iterate subcarteras and attach model context for each
      const names     = suscripcion.subcarteras.split(',');
      const ids       = suscripcion.idsubcarteras.split(',');
      const opts      = suscripcion.idcarteraoptima ? suscripcion.idcarteraoptima.split(',') : [];
      const periodos  = suscripcion.periodo ? String(suscripcion.periodo).split(',') : [];
      const metaapis  = suscripcion.metaApi ? String(suscripcion.metaApi).split(',') : [];
      console.log(suscripcion);
      ids.forEach((_: string, i: number) => {
        const symbol         = names[i]?.trim() || '';
        const idModelo       = ids[i]?.trim()   || '';
        const idCarteraOptima = opts[i]?.trim() || '';
        const periodo = Number(periodos[i] ?? 6) || 6;
        const metaapi = metaapis[i]?.trim() === 'true';
        if (symbol) {
          charts.push({
            symbol,
            label: symbol,
            idModelo,
            idCarteraOptima,
            fechaRegistroSuscripcion: this.fecharegistrosuscripcion,
            suscripcion: suscripcion,
            metaapi,
            periodo
          });
        }
      });
    } else {
      // Fallback: build charts from the cartera operations grouped by unique iso. El iso se pide a
      // listarconid: puede acabar en cifras (US30) y el contador del isooper no tiene longitud fija.
      const idNectums = Array.from(new Set(this.allOpedataRaw.map((op: any) => op.idNectum).filter(Boolean)));
      this._sseservice.apiPostNew('listarconid', idNectums, this.licencia).pipe(
        catchError(() => of([]))
      ).subscribe((resp: any) => {
        const isoPorIdNectum = new Map<number, string>(
          (resp || []).filter((r: any) => r.iso).map((r: any) => [r.idNectum, r.iso] as [number, string])
        );
        const seen = new Set<string>();
        this.allOpedataRaw.forEach((op: any) => {
          const base = op.isooper ? isoDeIsooper(op.isooper, isoPorIdNectum.get(op.idNectum)) : '';
          if (base && !seen.has(base)) {
            seen.add(base);
            charts.push({ symbol: base, label: base });
          }
        });
        this.chartsData = { charts };
        this.showChartsSection = true;
      });
      return;
    }

    this.chartsData = { charts };
    this.showChartsSection = true;
  }

  showHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Suscripciones',
      items: [
        { term: 'Carteras', description: 'Lista de carteras disponibles para suscripción. Muestra el nombre de cada cartera configurada.' },
        { term: 'Subcarteras', description: 'Modelos asociados a cada cartera. Puede hacer clic en el nombre para ver detalles del modelo.' },
        { term: 'Suscrito', description: 'Indica si la cartera está suscrita. Debe estar marcada para poder activar funciones automáticas.' },
        { term: 'Broker/Gestor', description: 'Módulo donde está activa la suscripción (Broker para operativa real, Gestor para simulación).' },
        { term: 'Automático', description: 'Automatizamos la operatica de una cartera suscrita. Solo disponible si la cartera está suscrita previamente.' },
        { term: 'Control Operativa', description: 'Muestra las posiciones y las órdenes de la cartera suscrita (botones de la barra de herramientas).' },
        { term: 'Stop Loss', description: 'Precio al que se cerrará automáticamente una posición para limitar pérdidas. Se establece, actualiza o cancela con clic derecho sobre la posición. En la lista de órdenes, la flecha ↑/↓ junto a una STP indica que el Stop Loss dinámico ya subió y se puede actualizar.' },
        { term: 'Profit', description: 'Precio objetivo al que se cerrará automáticamente una posición para asegurar ganancias. Se establece o cancela con clic derecho sobre la posición.' },
        { term: 'Operaciones no enviadas', icon: 'warning', iconColor: '#ff9800', description: 'El aviso de la barra de herramientas cuenta las operaciones que la automatización no llegó a enviar al broker. Haga clic para ver el detalle.' },
        { term: 'Automatización Detenida', icon: 'pause_circle_filled', iconColor: '#ff9800', description: 'Automatización pausada' },
        { term: 'Margen Broker Insuficiente', icon: 'warning', iconColor: '#ff9800', description: 'Margen insuficiente en broker' },
        { term: 'Margen Insuficiente', icon: 'warning', iconColor: '#ff9800', description: 'Margen insuficiente en la Cartera suscrita' },
        { term: 'Riesgo de cartera superado', icon: 'warning', iconColor: '#ff9800', description: 'Riesgo de la Cartera suscrita superado' },
        { term: 'Broker Cerrado', icon: 'close', iconColor: '#ff9800', description: 'Broker no disponible o fuera de horario' },
        { term: 'Pendiente Envío', icon: 'pending_actions', iconColor: '#ff9800', description: 'Pendiente de envío al broker' },
        { term: 'Error', icon: 'error', iconColor: '#f44336', description: 'Error en la ejecución de la operación' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '500px',
      data: helpData
    });
  }

  public refrescar() {
    if (!(this.idcartera > 0)) return;
    this._sseservice.apiGetWithAuth(`operaciones/${this.idcartera}`, this._cookieService.get('auth_token')).subscribe({
      next: (data: any) => this.setOperaciones(data)
    });
  }
}
